function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "23",
  height: "29",
  x: "8.5",
  y: "5.5",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 26.5h-13m9 3h-9m13-6h-13m9.08-11.28a2 2 0 00-2-1.38 1.81 1.81 0 00-2 1.73c0 1 .87 1.39 2.09 1.82s1.91.78 2 1.74C22.66 18 20.75 18 20.49 18a2.12 2.12 0 01-2.17-1.65m2.26 3.51v-1.65m0-7.46V9.19"
}));